import LabeledCheckBox from 'admin/components/molecules/LabeledCheckBox';
import React from 'react';

type Option = {
  labelText: string;
  value: string;
};

type Props = {
  name: string;
  options: Option[];
  values: string[];
  onChange: (values: string[]) => void;
};

const CheckBoxList = ({ name, options, values, onChange }: Props) => (
  <>
    {options.map((option) => (
      <LabeledCheckBox
        key={option.value}
        id={`${name}-${option.value}`}
        labelText={option.labelText}
        labelPosition="right"
        checked={values.includes(option.value)}
        setChecked={(checked) =>
          onChange(checked ? values.concat(option.value) : values.filter((v) => v !== option.value))
        }
      />
    ))}
  </>
);

export default CheckBoxList;
